import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

function KlarnaSignupService() {
    this._submit = function (evt, eventData) {
        let success = function (data) {
            this._handleResult(data);
        };

        this._post({
            url: '/my/klarna-signup',
            data: eventData,
            success: success.bind(this),
            error: 'data:klarna-signup:on-submit-error'
        });
    };

    this._handleResult = function (data) {
        let payload = data;
        this.trigger(document, 'data:klarna-signup:after-submit', payload);
    };

    this.after('initialize', function () {
        this.on('ui:klarna-signup:submit', this._submit);
    });
}

export default defineComponent.component(KlarnaSignupService, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/klarna-signup-service.js